import { useEffect, useState } from "react";

/**
 * Returns true when the viewport is desktop-sized (>= 1024px, Tailwind `lg`).
 * Used to gate framer-motion animations and heavy ambient decorations so
 * mobile/tablet renders remain static (no janky animations, no glitches).
 */
export default function useIsDesktop() {
  const query = "(min-width: 1024px)";
  const [isDesktop, setIsDesktop] = useState(() => {
    if (typeof window === "undefined") return true;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const mql = window.matchMedia(query);
    const onChange = (e) => setIsDesktop(e.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isDesktop;
}
